import { FormattedMessage } from 'react-intl';
import { InfoBlocks } from '@atoms/dataDisplay';

import { DelayedLinearProgress } from '@molecules/feedback';
import Fade from '@mui/material/Fade';
import { Box } from '@atoms/layout';
import { EmptyListPlaceholder } from '@molecules/dataDisplay';
import { FaIcon } from '@atoms/icons';
import { useTheme } from '@mui/material';

type TabProps = {
  notes: string[];
  loading: boolean;
};
export function ShiftNotes({ notes, loading }: TabProps) {
  const theme = useTheme();
  const additionalNotes: string[] = [];

  return (
    <>
      <DelayedLinearProgress show={loading} />
      {!notes.length && (
        <EmptyListPlaceholder
          icon={<FaIcon name="memo-pad" variant="duotone" color={theme.palette.primary.light} />}
          title={<FormattedMessage id="shifts.notNotes" />}
        />
      )}
      <Fade in={notes.length > 0}>
        <Box>
          <InfoBlocks
            // title={<FormattedMessage id="shifts.dayOneInstructions" />}
            items={notes.map((note, idx) => ({
              key: '' + idx,
              value: note,
            }))}
            columns={1}
          />
        </Box>
      </Fade>
      <Fade in={additionalNotes.length > 0}>
        <Box>
          <InfoBlocks
            title={<FormattedMessage id="shifts.additionalNotes" />}
            items={additionalNotes.map((note, idx) => ({
              key: '' + idx,
              value: note,
            }))}
            columns={1}
          />
        </Box>
      </Fade>
    </>
  );
}
